import { createSelector } from 'reselect'

const quiz_question_server_selector = serverId => createSelector(
	[ state => state.quiz ],
	quizState => {
		const question = quizState.questions.find(question => question.serverId === serverId)
		return {
			questionId: question.id,
		}
	}
)

export default quiz_question_server_selector
